<template>
<div>
    <div style="background: #ffffff;position:relative;">
        <div class="search-condition-con" :class="isShowMore && 'show'">
            <div class="search-condition" >
                <span class="label">代理商</span>
                <div class="input-condition" >
                    <factor-auto-complete v-model="condition.factorID" clearable></factor-auto-complete>
                </div>
            </div>
            <div class="search-condition">
                <span class="label">站点</span>
                <div class="input-condition">
                    <site-auto-complete v-model="condition.siteID" clearable :factor-id="condition.factorID"></site-auto-complete>
                </div>
            </div>
            <div class="search-condition">
                <span class="label">400号码</span>
                <div class="input-condition" >
                    <el-autocomplete v-model="condition.tellnumber" :fetch-suggestions="querySearchHotline" placeholder="请输入400号码"  valueKey="hotline_number"></el-autocomplete>
                </div>
            </div>
            <div class="search-condition">
                <span class="label">费用状态</span>
                <div class="input-condition">
                    <el-select v-model="condition.balanceStatus" >
                        <el-option value="" label="不限"></el-option>
                        <el-option value="3" label="欠费"></el-option>
                        <el-option value="0" label="正常"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="search-condition">
                <span class="label">400号码状态</span>
                <div class="input-condition">
                    <el-select v-model="condition.status" >
                        <el-option value="" label="不限"></el-option>
                        <el-option value="0" label="启用"></el-option>
                        <el-option value="1" label="禁用"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="search-condition">
                <span class="label">400号码类</span>
                <div class="input-condition">
                    <el-select v-model="condition.type" >
                        <el-option value="" label="不限"></el-option>
                        <el-option value="2" label="公共大号"></el-option>
                        <el-option value="1" label="独立大号"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
        <div class="btn-condition">
            <el-button @click="handleSearch" type="primary">查 询</el-button>
            <el-button  @click="resetSearch" >清空条件</el-button>
        </div>
    </div>

    <div>

        <el-table
                :data="list"
                style="width: 100%"
                :highlight-current-row="true"
                stripe
                tooltip-effect="dark"
                ref="multipleTable"
                v-loading="isLoading"
                header-cell-class-name="table-back"
        >
            <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
            <el-table-column  width="120"  label="代理商" prop="factor_name" ></el-table-column>
            <el-table-column  label="归属站点" prop="service_type"></el-table-column>
            <el-table-column  label="费用状态" prop="balance"></el-table-column>
            <el-table-column width="120" label="400号码" prop="hotline_number"></el-table-column>
            <el-table-column  label="号码状态" prop="tstatus"></el-table-column>
            <el-table-column  label="号码类型" prop="type"></el-table-column>
            <el-table-column  width="90" label="分机号位数" prop="telephone_length"></el-table-column>
            <el-table-column  width="120" label="已占用分机号" prop="bind_cnt"></el-table-column>
            <el-table-column  width="120" label="可使用分机号" prop="use_cnt"></el-table-column>
            <el-table-column  width="120" label="已冻结分机号" prop="frozen_cnt"></el-table-column>
            <el-table-column   width="120" label="月最低消费" prop="minimum_charge_yuan"></el-table-column>
            <el-table-column   align="center" width="150"  label="绑定时间" prop="updated_at"></el-table-column>
            <el-table-column  label="操作人" prop="operator"></el-table-column>
            <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
            <el-table-column width="180" >
                <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                <template slot="header"   slot-scope="scope">
                    <span style="color: #409EFF">操作</span>
                </template>
                <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                <template slot-scope="scope">
                    <el-button  v-if='scope.row.status ==1' size="mini" @click="handleStart(scope.$index, scope.row)" v-permission="'business.hotline.changescustomerstatus'">启用</el-button>
                    <el-button  v-if='scope.row.status ==0' size="mini" @click="handleStop(scope.$index, scope.row)" v-permission="'business.hotline.changescustomerstatus'">禁用</el-button>
                    <el-button size="mini"  @click="handleRescission(scope.$index, scope.row)" v-permission="'business.hotline.customerstatusrescission'">解绑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
        <template v-if="list.length > 0">
            <!-- :total="list.length" -->
            <el-pagination background layout="total,prev, pager, next" :total="pages.total" :page-size="pages.size" @current-change="currentChange"></el-pagination>
        </template>
    </div>
</div>
</template>
<style>
    .search-condition-con .search-condition{
        width: 30%;
    }
</style>
<script>
    import {
        getHotlinesForBind,
        editCunstomerHotlinesStatus,
        getHotlinesall,
        getHotlinesUse
    } from "../../../../service/hotline";
    import {CunstomerHotlinesrescission} from "../../../../service/hotline";
    import {getFactorsList} from "../../../../service/user";
    import {getSite} from "../../../../service/site";
    import FactorAutoComplete from "../../../../components/auto-complete/factor-auto-complete";
    import SiteAutoComplete from "../../../../components/auto-complete/site-auto-complete";
    export default {
        name: 'bind',
        components: {SiteAutoComplete, FactorAutoComplete},
        data () {
            return {
                page:1,
                balacneStatusMap:{
                    3:'欠费'
                },
                statusMap:{
                    0:'正常',
                    1:'禁用',
                },
                typeMap:{
                    1:'独立大号',
                    2:'公共大号'
                },
                pages:{
                    total:'',
                    size:''
                },
                condition: {
                    factorID:'',
                    siteID:'',
                    type: '',
                    status:'',
                    tellnumber:'',
                    balanceStatus:''
                },
                isLoading: false, // 是否显示loading加载
                list: [],
                isShowMore: false
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            //用于站点自动补全的查询
            async querySearchHotline(queryString, callback) {
                let result = [];
                let query = {};
                query['hotline_number'] = queryString;
                await getHotlinesall(query).then((data) => {
                    result = data
                });
                callback(result)
            },
            //清空
            resetSearch() {
                this.condition = {
                    factorID:'',
                    siteID:'',
                    factor: '',
                    site: '',
                    type: '',
                    status:'',
                    tellnumber:'',
                    balanceStatus:''
                };
                this.refreshPage();
            },
            //分页设置回调
            currentChange(page) {
                this.page = page;
                this.refreshPage();
            },
            //搜索
            handleSearch() {
                this.refreshPage();
            },
            //启用商户大号
            handleStart(i,row) {
                this.$confirm('启用后，该400号码可以正常新增绑定修改分机号，是否确认？', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 0;
                    this.isLoading = true;
                    editCunstomerHotlinesStatus(row.id,query).then(data=>{
                        this.refreshPage()
                    });
                    this.isLoading = false
                }).catch((e) => {
                    this.message({
                        content:e.message,
                        type:'error'
                    })
                });


            },
            //禁用商户大号
            handleStop(i,row) {
                this.$confirm('禁用后，该400将禁止新增绑定修改分机号，是否确认？', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 1;
                    this.isLoading = true;
                    editCunstomerHotlinesStatus(row.id,query).then(data=>{
                        this.refreshPage()
                    });
                    this.isLoading = false
                }).catch((e) => {
                });

            },
            //禁用商户大号
            handleRescission(i,row) {
                this.$confirm('解绑后将解除该400号码与站点以及分机号所有的绑定关系，不可恢复，是否确认操作？', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 1;
                    CunstomerHotlinesrescission(row.id,query).then(data=>{
                        this.refreshPage()
                    });
                    this.isLoading = false
                }).catch((e) => {
                });
            },
            //刷新列表
            refreshPage() {
                let query = {};
                let form =  this.condition;
                query['factor_id'] = form.factorID;
                query['site_id'] = form.siteID;
                query['type'] = form.type;
                query['status'] = form.status;
                query['hotline_number'] = form.tellnumber;
                query['balance_status'] = form.balanceStatus;
                query['page'] = this.page;
                // this.$message({
                //     type: '',
                //     message: err.message || '删除失败'
                // })
                this.isLoading = true;
                //query['factor_id'] = user.factor_id
                getHotlinesUse(query).then((data) => {
                    let listData = data;
                    listData.data.forEach((item,i,list)=>{
                        //非欠费状态都是正常
                        if(!item.service_type.trim()) {
                            listData.data[i].site_name = '--'
                        }

                        if(!this.balacneStatusMap[item.status]) {
                            listData.data[i].balance = '正常'
                        } else {
                            listData.data[i].balance = this.balacneStatusMap[item.status]
                        }
                        if(!this.statusMap[item.status]) {
                            listData.data[i].tstatus = '禁用'
                        } else {
                            listData.data[i].tstatus =this.statusMap[item.status]
                        }
                        if (item.only_user_400 == 1) {
                            listData.data[i].hotline_number += '（直拔号）';
                        }
                        listData.data[i].type = this.typeMap[item.type]
                    });
                    this.list = listData.data;
                    this.pages.size = data.pre_page;
                    this.pages.total = data.total
                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            /** 初始化数据请求 */
            async initData () {
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                let query = {};
                this.refreshPage();
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            }
        }
    }
</script>
